import { ChatMessage } from '../entity';

export class ChatMessageAddedEvent {
  constructor(public messages: ChatMessage[]) {}
}
